import { useState, useEffect, useRef } from 'react';

/**
 * 伪debounce封装，渗透两个变量，第一个是告诉外部，是否是可执行时机，第二个是套壳函数
 * @param {number} timeout - 隔多久会响应
 */

const useDebounce = (timeout = 800) => {
  const [executable, setExecutable] = useState(false);
  const [timer, setTimer] = useState(undefined);

  const timeFn = () => {
    const timeRecord = setTimeout(() => {
      setExecutable(true);
      clearTimeout(timeRecord);
      setTimer(undefined);
      setExecutable(false);
    }, timeout);
    setTimer(timeRecord);
  };

  const judgement = useRef(timer);
  useEffect(() => {
    judgement.current = timer;
  });

  const deBouncedFn = () => {
    if (!judgement.current) {
      timeFn();
    } else {
      clearTimeout(timer);
      timeFn();
    }
  };

  return [executable, deBouncedFn];
};

export default useDebounce;
